module.exports = __webpack_public_path__ + "img/success.77242f1a.png";